module.exports = __webpack_public_path__ + "static/media/e28d8023-da50-49e3-8155-f1c44b436efe.26e62a9f.png";